import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {combineLatest} from 'rxjs';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {OtsDataSharingModal} from 'src/app/shared/model/ots-data-sharing.model';
import {Carriage,ISubRuleMySuffix,Shipping,ShippingPlaceLimit,SubRuleMySuffix} from 'src/app/shared/model/subrule-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {currenyMaskService} from '../../shared/currencyMask.service';
import {CountryMySuffixService} from '../country-my-suffix';
import {SubRuleMySuffixService} from './sub-rule-my-suffix.service';
declare var $: any;

@Component({
    selector: 'jhi-sub-rule-my-suffix-update',
    templateUrl: './sub-rule-my-suffix-update.component.html'
})
export class SubRuleMySuffixUpdateComponent implements OnInit {

    countries: ICountryMySuffix[];
    allCountries: ICountryMySuffix[];
    transportedFromToListData = [];
    _subRule: ISubRuleMySuffix = new SubRuleMySuffix();
    carriageList: any;
    shippingList: any;
    placeLimitList: any;
    keys = Object.keys;
    values = Object.values;
    ruleId: number;

    numberPattern = '^[0-9]+(.[0-9]{0,9})?$';
    onlyNumberPattern = "^[0-9]*$";

    dropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };
    rateOptions: any;
    policyMarkerType: any;
    isFromAutomateOts:boolean = false;
    scopeId;
    isMoreThanOneSubrule: boolean=false;
    subRuleData: ISubRuleMySuffix;

    constructor(
        private jhiAlertService: JhiAlertService,
        private activatedRoute: ActivatedRoute,
        private currencyMask: currenyMaskService,
        private principal: Principal,
        private subRuleService: SubRuleMySuffixService,
        private countryService: CountryMySuffixService,
        private router:Router,
        private languageChangeService: LanguageChangeService,
        private stateStorageService: StateStorageService

    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }

    otsSummaryPageUrl: string = '';
    otsKeyword: string = '';
    isOts: boolean = false;
    isSubRuleOtsEdit: boolean = false;
    scopeDataId: string;

     dataSharingModal:OtsDataSharingModal=null;
    randomOtsId=null;

    
    ngOnInit() {
        this.otsSummaryPageUrl = "";
        this.subRule.premiumRate = 0;

        console.log('SubRuleMySuffixUpdateComponent----');
        this.rateOptions = this.currencyMask.ratePrecisionOptions;
        window.scroll(0, 0);
        // this.getCountries();
        this.carriageList = Carriage;
        this.shippingList = Shipping;
        this.placeLimitList = ShippingPlaceLimit;
        this.countries = [];


        this.ruleId=this.activatedRoute.snapshot.params['ruleId'];
        this.policyMarkerType = this.activatedRoute.snapshot.params['policyMarketType'];

        this.checkPremiumCalculationPermission();

        this.scopeId=this.activatedRoute.snapshot.params['scopeId'];
        this.scopeDataId=this.activatedRoute.snapshot.params[ 'scopeDataId' ];
        
        this.scope=this.scopeId;

        // const IS_FROM_AUTOMATE_OTS: string = localStorage.getItem("isFromAutomateOts");
        // const CURRENT_URL: string = this.router.url;
        // this.isOts = CURRENT_URL.includes('ots');
        

        // if(this.isFromAutomateOts) {
        //     const OTS_URL: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);
        //     if(OTS_URL && this.isOts) {
        //         this.otsSummaryPageUrl = JSON.parse(OTS_URL);
        //         // this.otsKeyword = 'ots';
        //     }
        // }
        
        // this.isMoreThanOneSubrule=this.activatedRoute.snapshot.params['otherRule']!=undefined;
        // console.log(this.subRule.premiumRate)
        // if(!this.isMoreThanOneSubrule) {
        //     localStorage.removeItem("subRules");
        // } else {
        //     this.subRule.premiumRate = 0;
        // }

        
        // console.log(localStorage.getItem('isAddSubRuleClicked'));
        // console.log(localStorage.getItem('scopeId'));

        
        this.isSubRuleOtsEdit = this.activatedRoute.snapshot.queryParams['isSubRuleOtsEdit'];
        let paramData = this.activatedRoute.snapshot.queryParams['sharedData'];
        
        if(paramData!=null){  
            this.dataSharingModal = JSON.parse(paramData);
            this.isFromAutomateOts = this.dataSharingModal.isOts;
            this.scopeId=this.dataSharingModal.otsScopeId;
            this.ruleId = +this.dataSharingModal.otsRuleId;
            this.policyMarkerType = this.dataSharingModal.policyScopeType;
            this.isSubRuleOtsEdit = this.dataSharingModal.isEdit;
            this.scopeDataId= this.scopeId;
            this.scope = this.scopeId;
            
            const OTS_URL: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);
            if(OTS_URL && this.isFromAutomateOts) {
                this.otsSummaryPageUrl = JSON.parse(OTS_URL);
            }
        } else if(this.activatedRoute.snapshot.params[ 'ots' ]!=undefined) {
            this.isFromAutomateOts = this.activatedRoute.snapshot.params['ots']!=undefined;
        }
        
        
        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];

        if(this.randomOtsId!=null && this.stateStorageService.contains(this.randomOtsId)) {
            this.otsSummaryPageUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.isFromAutomateOts=true;
        }

        
        this.isAddSubRule = JSON.parse(localStorage.getItem('isAddSubRuleClicked'));

        // this.scope = JSON.parse(localStorage.getItem('scopeId'));
        
        // if(!this.isAddSubRule ||  this.scope ==  null || this.scope == undefined){
            if(!this.isAddSubRule ||  CommonUtils.isNil(this.scope)){
            localStorage.removeItem("isAddSubRuleClicked");
            localStorage.removeItem("scopeId");
        } 

        let param=this.activatedRoute.data;
        let contryQuery=this.countryService.query();

        combineLatest(param,contryQuery).subscribe(res => {
            // console.log(res[0]);
            // console.log(res[1]);
            this.subRule=res[0].subrule;
            this.allCountries=res[1].body;


            if(this.subRule && this.subRule.id) {
                if(this.isAddSubRule || this.isMoreThanOneSubrule){
                    this.subRule.premiumRate =0
                }
                this.getCountriesByRUleIdAndCarriage(this.ruleId,this.subRule.carriage);
                
                // if(this.subRule && this.subRule.id && !this.allCountries && this.allCountries.length==0){
                //     this.filterTransportedCOuntries(this.subRule.countryList);
                // }
            }
        });

        // this.activatedRoute.data.subscribe(data => {
        //     this.subRule = data.subrule;
        //     if(this.subRule.id) {
        //         this.getCountriesByRUleIdAndCarriage(this.ruleId,this.subRule.carriage);
        //     } else {
        //         this.getCountries();
        //     }
        // });


    }

    getCountries() {
        this.countryService.query().subscribe(res => {
            this.allCountries=res.body;
            if(this.subRule && this.subRule.id && !this.allCountries && this.allCountries.length==0){
                this.filterTransportedCOuntries(this.subRule.countryList);
            }
        }, err => this.onError(err.message))
    }

    getCountriesByRUleIdAndCarriage(ruleId, carriage) {
        this.countries = [];
        const countries: any[] = [];
        this.subRuleService.get('api/from-or-to-countries/' + ruleId + '/' + carriage).subscribe(res => {
            this.countries=res.body;
            // console.warn(this.countries);
            if(this.subRule.countryList && this.subRule.countryList.length > 0) {
                // console.warn(this.subRule.countryList);
                for(let i = 0; i < this.subRule.countryList.length; i++) {
                    for(let j = 0; j < this.countries.length; j++) {
                        if(this.subRule.countryList[i].id === this.countries[j].id) {
                            countries.push(this.countries[j]);
                        }
                    }
                }
                this.subRule.countryList = countries;
                // console.warn(this.subRule.countryList);
            }
            this.filterTransportedCOuntries(this.subRule.countryList);
        }, err => {
            this.onError(err.message);
        });
    }


    handleEnterKeyPress(event) {
        const tagName = event.target.tagName.toLowerCase();
        if (tagName !== 'textarea') {
            return false;
        }
    }


    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    get subRule() {
        return this._subRule;
    }

    set subRule(subRule: ISubRuleMySuffix) {

        this._subRule = subRule;
        if(subRule.countryList==null||subRule.countryList.length==0) {
            this.transportedFromToListData=this.allCountries;
        }
    }
    
    filterTransportedCOuntries(subRuleCountryList) {
        this.transportedFromToListData = [];
        if (this.allCountries && this.allCountries.length>0 && subRuleCountryList && subRuleCountryList.length == 0) {
            this.transportedFromToListData = [...this.allCountries];
            return;
        }
        if (this.allCountries && this.allCountries.length > 0) {
            this.allCountries.forEach((obj) => {
                var existCOuntry = subRuleCountryList.find(({ id }) => obj.id === id);
                if (!existCOuntry) {
                    this.transportedFromToListData.push(obj);
                }
            });
        }

    }

    onCarriageChange(event) {
        this.getCountriesByRUleIdAndCarriage(this.ruleId, this.subRule.carriage);
        this.clearCOuntryList();
        //clear rest of the dependent properties
    }
    clearCOuntryList() {
        this.subRule.countryList = [];
        this.clearShipping();

    }
    clearShipping() {
        this.subRule.shipping = null;
        this.clearCarriedList(null);
    }
    clearCarriedList(event) {
        
        event =  event == null?this.subRule.countryList:event;
        this.subRule.transportedFromToList = [];
        this.filterTransportedCOuntries(event);
    }
    clearPlaceLimit() {
        this.subRule.placeLimit = null;
        this.clearKmLimit();
    }
    clearKmLimit() {
        this.subRule.kmLimit = null;
    }

    //countries list
    onSelectCountryList(event) {
        
        this.clearCarriedList(null);
    }
    onDeSelectCountryList(event) {
        this.clearCarriedList(null);
    }
    onSelectALLCountryList(event) {
        console.log(event);
        this.clearCarriedList(event);
    }
    onDeSelectALLCountryList(event) {
        console.log(event);
        this.clearCarriedList(event);
    }


    //shipping
    onShippingListChange(event) {
        this.clearPlaceLimit();
        this.clearCarriedList(null);
    }

    //carriedCountries
    onSelectCarriedCountryList(event) {
    }
    onDeSelectCarriedCountryList(event) {
    }
    onSelectALLCarriedCountryList(event) {
    }

    onDeSelectALLCarriedCountryList(event) {
    }

    onPlaceLimitListChange(event) {
        this.clearKmLimit();
    }

    save() {
        if (this.subRule.placeLimit == 'WITHIN_PORT_SURROUNDING' && this.subRule.kmLimit > 200) {
            this.onError("Km limit must not exceed 200");
            return;
        }
        else if(this.subRule.placeLimit == 'KM_LIMITATIONS' && this.subRule.kmLimit >  100000) {
            this.onError("Km limit must not exceed 100000");
            return;
        }
       
        if(this.isFromAutomateOts && (this.isSubRuleOtsEdit === false)) {
            this.subRule.id=null;
        }
       
        this.subRule.ruleId = this.ruleId;
        this.subRule.policyMarketType = this.policyMarkerType;

        this.subRuleService.post(this.subRule).subscribe(res => {

            if(this.isFromAutomateOts){   // only in ots
                if(this.dataSharingModal && this.dataSharingModal.oldSubRules && this.dataSharingModal.oldSubRules.length>1) { // when pre post both are present
                    
                    localStorage.removeItem("subRules");
                    if(this.scopeDataId && this.subRule.carriage!='POST') {  // when submitting pre , redirect to post
                        this.router.navigate(['sub-rule-my-suffix/new/ots/', this.dataSharingModal.oldSubRules[1].id,'add'],{queryParams:{sharedData:JSON.stringify(this.dataSharingModal),ranOtsId:this.randomOtsId}})
                        // this.router.navigateByUrl('/sub-rule-my-suffix/new/'+this.dataSharingModal.oldSubRules[1].id+'/'+this.ruleId+"/ots/"+this.scopeDataId);
                    } else {  // if post submitting , redirect to view page of ots
                        this.router.navigate(['rule-my-suffix/'+this.ruleId+'/'+this.scopeId+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
                    }
                } else {
                    
                    this.router.navigate(['rule-my-suffix/'+this.ruleId+'/'+this.scopeId+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
                } 
            }else{ // in normal flow
                this.previousState();
            }
        
        }, err => this.onError(err.message));
    }

    isAddSubRule: boolean= false;
    scope: any;
    previousState() {
        if(this.isFromAutomateOts && this.otsSummaryPageUrl) {
            
            this.router.navigate(['rule-my-suffix/'+this.ruleId+'/'+this.scopeId+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
        } else if(this.isAddSubRule && this.ruleId && this.scopeId){
            
            localStorage.removeItem('isAddSubRuleClicked');
            localStorage.removeItem('scopeId');
            this.router.navigateByUrl('rule-my-suffix/'+this.ruleId+'/'+this.scopeId+'/view');
            
        }else {
            window.history.back();
        }
    }
    isPremiumCalculationDisable:boolean;
    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }


}
